// extracted by mini-css-extract-plugin
export default {"SdksLink":"Sdks_SdksLink__ZcrgO"};